import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';

@Component({
  selector: 'app-why-choose-us',
  templateUrl: './why-choose-us.component.html',
  styleUrls: ['./why-choose-us.component.scss']
})
export class WhyChooseUsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('為何選擇 Trinka AI 打造您專屬且擁有所有權的客製化 AI 模型？');
    this.metaTagService.updateTag({ name: 'description', content: "探索 Trinka AI 成為您專屬 AI 模型合作夥伴的理由，您全面掌控 AI，擁有完整智慧財產權，並享有依業務需求量身打造、可彈性擴展的專屬解決方案。立即將 AI 化為您最珍貴的資產，開啟智慧未來！" });
    this.metaTagService.updateTag({ property: 'og:title', content: "為何選擇 Trinka AI 打造您專屬且擁有所有權的客製化 AI 模型？" });
    this.metaTagService.updateTag({ property: 'og:description', content: "探索 Trinka AI 成為您專屬 AI 模型合作夥伴的理由，您全面掌控 AI，擁有完整智慧財產權，並享有依業務需求量身打造、可彈性擴展的專屬解決方案。立即將 AI 化為您最珍貴的資產，開啟智慧未來！" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/why-choose-us' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/why-choose-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '為何選擇 Trinka AI 打造您專屬且擁有所有權的客製化 AI 模型？' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "探索 Trinka AI 成為您專屬 AI 模型合作夥伴的理由，您全面掌控 AI，擁有完整智慧財產權，並享有依業務需求量身打造、可彈性擴展的專屬解決方案。立即將 AI 化為您最珍貴的資產，開啟智慧未來！" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/custom-ai-models/why-choose-us' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/custom-ai-models/why-choose-us' });

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    // console.log("Country is", this.country);
  }

}
